import { render, staticRenderFns } from "./ArticlesFilters.vue?vue&type=template&id=aca3edb4"
import script from "./ArticlesFilters.vue?vue&type=script&lang=js"
export * from "./ArticlesFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports